<div class="row mb-3">
  <div class="col-12">
    <div class="row">
      <div class="col-12 " [ngClass]="{'col-xxl-8': hasStatus}">
        <div class="row">
          <div class="col-12">
            <ui-fh-text [type]="'PAGE-TITLE'" [text]="title | translate"></ui-fh-text>
          </div>
          <div class="col-12" *ngIf="subtitle">
            <ui-fh-text [class]="'page-title md-f-size'" [type]="'TEXT'" [text]="subtitle | translate"></ui-fh-text>
          </div>
          <div class="col-12" *ngIf="description && description != (description | translate:descriptionParams)">
            <ui-fh-text [type]="'PAGE-DESCRIPTION'" [text]="description | translate:descriptionParams"></ui-fh-text>
          </div>
        </div>
      </div>
      <div class="col-12 col-xxl-4 mt-3 mt-xxl-0 d-flex justify-content-end mb-2" *ngIf="hasStatus">
        <ui-fh-status
          [useHeaderCard]="true"
          [translateKeyPrefix]="statusTranslatePrefix"
          [status]="normalizedStatus">
        </ui-fh-status>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="options">
      <div class="buttons-list d-flex flex-column flex-lg-row justify-content-end flex-grow-1 row-gap-2 row-gap-lg-0 col-gap-0 column-gap-lg-2">
        <div class="button" *ngIf="cancelButton">
          <ui-fh-button
            [class]="'w-100'"
            [loading]="cancelButtonLoading"
            [disabled]="cancelButtonDisabled"
            [severity]="'secondary'"
            [label]="'generics.cancel' | translate"
            [icon]="this.appConfig.icon + ' fa-xmark'"
            (clickEvent)="clickedButtonHeader(true, 'cancel')"></ui-fh-button>
        </div>
        <div class="button" *ngIf="deleteButton">
          <ui-fh-button
            [class]="'w-100'"
            [loading]="deleteButtonLoading"
            [disabled]="deleteButtonDisabled"
            [severity]="'danger'"
            [label]="'generics.remove' | translate"
            [icon]="this.appConfig.icon + ' fa-trash'"
            (clickEvent)="clickedButtonHeader(true, 'delete')"></ui-fh-button>
        </div>
        <div class="button" *ngIf="editButton">
          <ui-fh-button
            [class]="'w-100'"
            [loading]="editButtonLoading"
            [disabled]="editButtonDisabled"
            [severity]="'secondary'"
            [label]="'generics.edit' | translate"
            [icon]="this.appConfig.icon + ' fa-pencil'"
            (clickEvent)="clickedButtonHeader(true, 'edit')"></ui-fh-button>
        </div>
        <div class="button" *ngIf="addButton">
          <ui-fh-button
            [class]="'w-100'"
            [loading]="addButtonLoading"
            [disabled]="addButtonDisabled"
            [severity]="'primary'"
            [label]="'generics.add' | translate"
            [icon]="this.appConfig.icon + ' fa-plus'"
            (clickEvent)="clickedButtonHeader(true, 'add')"></ui-fh-button>
        </div>
        <div class="button" *ngIf="saveButton">
          <ui-fh-button
            [class]="'w-100'"
            [loading]="saveButtonLoading"
            [disabled]="saveButtonDisabled"
            [severity]="'primary'"
            [label]="'generics.save' | translate"
            [icon]="this.appConfig.icon + ' fa-floppy-disk'"
            (clickEvent)="clickedButtonHeader(true, 'save')"></ui-fh-button>
        </div>
        <ng-container *ngIf="extraButtonsList.length > 0">
          <div class="button" *ngFor="let button of extraButtonsList">
            <ui-fh-button
              [class]="'w-100'"
              [loading]="button.loading || extraButtonLoading"
              [disabled]="button.disabled || extraButtonLoading"
              [severity]="button.severity"
              [label]="button.label | translate"
              [icon]="button.icon"
              (clickEvent)="clickedButtonHeader(false, button.tag)"></ui-fh-button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
